import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { ProductSection } from './components/ProductSection';
import { AudienceSection } from './components/AudienceSection';
import { ProofFaqSection } from './components/ProofFaqSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
import { RecentPurchaseNotification } from './components/RecentPurchaseNotification';
export function App() {
  return <div className="w-full min-h-screen bg-slate-900 font-sans selection:bg-brand-500/30 selection:text-brand-200" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Header data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <MechanismSection data-id="element-6" />
        <ProductSection data-id="element-7" />
        <AudienceSection data-id="element-8" />
        <ProofFaqSection data-id="element-9" />
        <PricingSection data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
      <RecentPurchaseNotification data-id="element-12" />
    </div>;
}